const domainName = window.location.hostname;
export const sitekey: string =
  domainName === (process.env.REACT_APP_DEV_DOMAIN_NAME as string)
    ? (process.env.REACT_APP_DEV_CAPTCHA_KEY as string)
    : domainName === (process.env.REACT_APP_MAIN_DOMAIN_NAME as string)
      ? (process.env.REACT_APP_MAIN_CAPTCHA_KEY as string)
      : domainName === (process.env.REACT_APP_MAIN_DOMAIN_NAME_AI as string)
        ? (process.env.REACT_APP_MAIN_CAPTCHA_KEY_AI as string)
        : (process.env.REACT_APP_LOCAL_CAPTCHA_KEY as string);

export const toggleConfirmPasswordType = (
  confirmPasswordType: any,
  setConfirmPasswordType: any
) => {
  confirmPasswordType === 'password'
    ? setConfirmPasswordType('text')
    : setConfirmPasswordType('password');
};

export const togglePasswordType = (passwordType: any, setPasswordType: any) => {
  passwordType === 'password' ? setPasswordType('text') : setPasswordType('password');
};

export const handleExpiredCaptcha = (setValue: any) => {
  setValue && setValue('recaptcha', '');
};
